import React, { useEffect, useState, useContext } from "react";
import { useRouter } from "next/router";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import { getDataFromSSR } from "@/handlers/client/commonClient";


const StatesConstituencyLiveResult = () => {
  const masterConfig = useContext(MasterConfigContext);
  const electionConfigData = masterConfig["assembly_widgets_2026"];
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const currentStateSlug = currentPath?.includes("elections") ? currentPath?.split("/")[3] : "west-bengal";
  // console.log("currentStateSlug", currentStateSlug);
  const autoLiveBlogRedirect = electionConfigData?.autoLiveBlogRedirect;

  const statesID =
    electionConfigData?.stateCategoryIDs ||
    [
      { name: "West Bengal", id: 709622, slug: "west-bengal" },
      { name: "Assam", id: 709621, slug: "assam" },

      { name: "Puducherry", id: 709623, slug: "puducherry" },
      { name: "Tamil Nadu", id: 709624, slug: "tamil-nadu" },
      { name: "Kerala", id: 709625, slug: "kerala" }
    ];


  const [stateId, setStateId] = useState(statesID?.find((state) => state.slug == currentStateSlug)?.id || statesID[0]?.id);
  const [selectedState, setSelectedState] = useState(statesID?.find((state) => state.slug == currentStateSlug) || statesID[0]);

  const [activeliveBlogs, setActiveliveBlogs] = useState([]);
  const [constituencyList, setConstituencyList] = useState([]);
  const [visibleList, setVisibleList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);



  const constituencyId =
    currentPath?.split("-")[currentPath?.split("-").length - 1];


  const getLiveBlogsData = async (pageNumber = 0) => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;

    try {
      const response = await getDataFromSSR(
        `${websiteUrl}/api/getLiveBlogElectionResult?id=${stateId}&page=${pageNumber}`
      );

      const fetchedData = response?.data?.data?.content || [];
      // console.log("fetchedData",pageNumber, fetchedData);
      if (pageNumber == 0) {
        setActiveliveBlogs(fetchedData);
      } else {
        setActiveliveBlogs((prev) => [...prev, ...fetchedData]);
      }
    } catch (error) {
      console.error("Error fetching live blogs:", error);
    }
  };


  useEffect(() => {
    setPage(0);
    setLoading(true);
    setActiveliveBlogs([]);
    setConstituencyList([]);
    setVisibleList([]);
    getLiveBlogsData(0);
  }, [stateId]);


  const selectAPI = (slug) => {
    return `https://akm-img-a-in.tosshub.com/sites/elections/2026/assembly/json/state-master/${slug}-state-master.json?v=1763056986`;
  };


  const electionPassedCategory = (slug) => {
    return `/assembly-chunav/${slug}`;
  };


  useEffect(() => {
    const fetchConstituencyData = async () => {
      if (!electionConfigData?.autoLiveBlog) return;
      // if (!activeliveBlogs?.length) return;

      try {
        const url = selectAPI(selectedState.slug);
        const response = await fetch(url);
        const data = await response.json();

        const blogs = activeliveBlogs;

        const activeTitles =
          blogs?.map((item) =>
            item?.title_short?.split(",")[0]?.trim().toLowerCase()
          ) || [];

        const filteredList =
          data?.data
            ?.filter((item) =>
              activeTitles.some((title) =>
                title.includes(item?.cons_name?.toLowerCase())
              )
            )
            ?.map((item) => {
              const matchedBlog = blogs.find((blog) =>
                blog?.title_short
                  ?.toLowerCase()
                  .includes(item?.cons_name?.toLowerCase())
              );

              return {
                ...item,
                blogUrl: matchedBlog?.canonical_url,
                cons_name_en: `${item?.cons_name} Election Result Live`,
              };
            }) || [];


        const uniqueList = Array.from(
          new Map(filteredList.map((i) => [i.cons_id, i])).values()
        );

        setConstituencyList(uniqueList);
        // setVisibleList(uniqueList.slice(0, 10));
        setVisibleList(uniqueList.slice(0, activeliveBlogs?.length));
      } catch (err) {
        console.error("Error fetching constituency data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConstituencyData();
  }, [activeliveBlogs, selectedState]);


  const handleLoadMore = () => {
    const currentLength = visibleList.length;
    const nextItems = constituencyList.slice(currentLength, currentLength + 10);
    const updatedList = [...visibleList, ...nextItems];
    const nextPage = page + 1;
    setPage(nextPage);
    getLiveBlogsData(nextPage);
    setVisibleList(updatedList);
  };

  if (loading) return null;
  // console.log("visibleList", visibleList);
  return (


    <section>
      <div className="my-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-2">
          <h2 className="flex text-xl font-semibold mb-1 md:mb-0">
            <span className="w-[5px] h-[auto] bg-primary inline-block mr-1"></span>
            2026 Assembly Constituencies Live Result
          </h2>


          <select
            value={stateId}
            onChange={(e) => {
              const selected = statesID.find(
                (s) => s.id == e.target.value
              );
              setStateId(selected.id);
              setSelectedState(selected);
            }}
            className="w-full md:w-2/5 bg-white text-[0.9rem] p-3 rounded-lg border-2"
          >
            {statesID.map((state) => (
              <option key={state.id} value={state.id}>
                {state.name}
              </option>
            ))}
          </select>
        </div>

        {visibleList?.length > 0 && <div className="my-1 bg-[#FFF] dark:bg-[#000] rounded-[10px]">
          <div className="flex flex-col border-2 border-[#E6E7E9] rounded-[20px] overflow-hidden">


            <div className="flex flex-wrap gap-x-2 gap-y-2 p-2">
              {visibleList?.map((item, index) => {
                const url = autoLiveBlogRedirect
                  ? `${process.env.NEXT_PUBLIC_WEBSITE_URL}/elections${electionPassedCategory(
                    selectedState.slug
                  )}/${item?.cons_name
                    .toLowerCase()
                    .replace(/[^a-zA-Z ]/g, "")
                    .split(" ")
                    .join("-")}-assembly-constituency-result-${item?.cons_id}`
                  : item.blogUrl;

                return (
                  <a
                    key={item?.cons_id || index}
                    href={url}
                    title={item?.cons_name}
                  >
                    <div
                      className={`border-2 rounded-[20px] px-4 py-2 ${item?.cons_id == constituencyId
                        ? "bg-primary text-white"
                        : "bg-[#EEF3F7]  hover:bg-primary hover:text-white"
                        }`}
                    >
                      <p className="whitespace-nowrap">
                        {item?.cons_name_en}
                      </p>
                    </div>
                  </a>
                );
              })}
            </div>


            <div className="w-full border-t border-[#E6E7E9]"></div>


            {visibleList.length >= 10 && (
              <div className="flex justify-center py-4">
                <button
                  onClick={handleLoadMore}
                  className="bg-primary text-white px-6 py-1.5 rounded-full text-sm"
                >
                  Load More
                </button>
              </div>
            )}
          </div>
        </div>}
      </div>
    </section>

  );
};

export default StatesConstituencyLiveResult;